/* eslint-disable prettier/prettier */
import ContentSkeleton from "@/components/Main/ContentSkeleton/ContentSkeleton.vue";
import EmptyFeed from "@/components/Main/EmptyFeed/EmptyFeed.vue";
import FeedContent from "../FeedContent/FeedContent.vue";

export default {
  name: "feed-component",
  props: ["feedFor", "feed", "circleState", "profileState", "canUserCreateContent", "contentLoading", "CIRCLE_STATES", "PROFILE_STATES"],
  components: {
    FeedContent,
    ContentSkeleton,
    EmptyFeed
  },
  methods: {
    sort(arr) {
      return arr.sort((a, b) => {
        const [A, B] = [a.created, b.created];
        if (A < B) {
          return 1;
        }
        if (A > B) {
          return -1;
        }
        return 0;
      });
    },
    addNewTopic() {
      this.$emit("stateChangeFromNav", this.$props.CIRCLE_STATES[1])
    }
  }
};
